import PropTypes from "prop-types";
import React from "react";
import Modal from "react-bootstrap/Modal";
import "./styles.scss";

export const InfoModal = ({ show, onHide, title, content }) => {
  return (
    <Modal show={show} onHide={onHide} centered className="info-modal" backdrop={true} keyboard={true}>
      <Modal.Body className="p-4">
        <button type="button" className="info-modal-close-btn" onClick={onHide} aria-label="Close modal">
          ×
        </button>
        <h5 className="modal-title text-center fw-bold mb-3">{title}</h5>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Modal.Body>
    </Modal>
  );
};

InfoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};
